import React, { useEffect, useState } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { ConfigProvider, theme, App as AppAntd } from 'antd';
import ptBR from 'antd/locale/pt_BR';

import { DefaultQueryClientConfig } from '../Defaults';
import { MasterPage } from './Views/Sistema/MasterPage';
import { SessaoARContext } from './Contexts/SessaoContext';
import { Splash } from './Views/Sistema/Splash';
import { TypeSessaoDaAreaRestrita } from '../Models/Domain/AreaRestrita/Sessao';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';

export const queryClient = new QueryClient({ ...DefaultQueryClientConfig });

export const AppAreaRestrita: React.FC = () => {

    const lsDarkTheme: string = "ARdarkTheme"

    const [sessao, setSessao] = useState<TypeSessaoDaAreaRestrita | null>(null);
    const temaAtual = localStorage.getItem(lsDarkTheme);
    const [temaEscuro, setTemaEscuro] = useState(
        temaAtual ? temaAtual === "1" : window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    );

    useEffect(() => {
        localStorage.setItem(lsDarkTheme, temaEscuro? '1' : '0')
    }, [temaEscuro] )

    useEffect(() => {
        localStorage.setItem("Rota_Get_AreaRestrita", (window.location.pathname.substring('/area-restrita'.length) ?? '') + (window.location.search ?? ''));
    }, []);

    return (
        <AppAntd>
            <ConfigProvider
                locale={ptBR}
                theme={{
                    algorithm: temaEscuro ? theme.darkAlgorithm : theme.defaultAlgorithm,
                    cssVar: true
                }}
                datePicker={{
                    style : {
                        width : "100%"
                    }
                }}
                rangePicker={{
                    style : {
                        width : "100%"
                    }
                }}
            >
                <QueryClientProvider client={queryClient}>
                    <SessaoARContext.Provider value={{ sessao, setSessao }}>
                        {
                            (() => {
                                if(sessao == undefined){
                                    return <Splash temaEscuro={temaEscuro}/>
                                }

                                return (
                                    <BrowserRouter basename='/area-restrita'>
                                        <MasterPage temaEscuro={temaEscuro} setTemaEscuro={setTemaEscuro}/>
                                    </BrowserRouter>
                                )
                            })()
                        }
                    </SessaoARContext.Provider>

                    {window.location.hostname === "localhost" &&
                        <ReactQueryDevtools initialIsOpen={false} />
                    }
                </QueryClientProvider>
            </ConfigProvider>
        </AppAntd>
    );
}
